var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row align-items-center h-100"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"clearfix"},[_c('h4',{staticClass:"pt-3"},[_vm._v("Please wait while signing in...")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 inlineSpinner"})])])])
}]

export { render, staticRenderFns }